import { render, staticRenderFns } from "./_MarketReportResult_consumption.vue?vue&type=template&id=4b9b20d0&scoped=true&"
import script from "./_MarketReportResult_consumption.vue?vue&type=script&lang=js&"
export * from "./_MarketReportResult_consumption.vue?vue&type=script&lang=js&"
import style0 from "./_MarketReportResult_consumption.vue?vue&type=style&index=0&id=4b9b20d0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b9b20d0",
  null
  
)

export default component.exports